<!-- <li class="panel"> -->
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(legaleIncaricato)"
				class="btn btn-primary associa" type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-3">{{legaleIncaricato.legale.nominativo}}</h4>
		<p class="col-sm-3">
			CF/P.IVA: <strong>{{legaleIncaricato.legale?.codiceFiscale}}</strong>
		</p>
		<p class="col-sm-2">
			<strong>{{legaleIncaricato.categoriaLegaleIncaricato?.label}}</strong>
		</p>
		<p class="col-sm-2 status"></p>
	</div>
</div>
<!-- </li> -->
